/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Authorize Application" |
*
* @param {Oauth_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_page_title = /** @type {((inputs?: Oauth_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autoriser l'application")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autorizar aplicación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Autorizar Aplicativo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizza Applicazione")
	return /** @type {LocalizedString} */ ("Authorize Application")
});